import Address from "./Address"
import Client from "./Client"
import Core from "./Core"
import Offers from "./Offers"
import Billing from "./Billing"
import Contract from "./Contract"
import List from "./List"

const Store = {
  namespaced: true,
  modules: {
    Core,
    Client,
    Address,
    Offers,
    Billing,
    Contract,
    List
  }
}

export default Store
